export default __webpack_public_path__ + "static/media/Size3.1ca1b499.png";